import { render, staticRenderFns } from "./Alarge.vue?vue&type=template&id=2039c2d0&scoped=true"
import script from "./Alarge.vue?vue&type=script&lang=js"
export * from "./Alarge.vue?vue&type=script&lang=js"
import style0 from "./Alarge.vue?vue&type=style&index=0&id=2039c2d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2039c2d0",
  null
  
)

export default component.exports